// src/components/FullViewportVideo.js
import React from 'react';
import YouTube from 'react-youtube';
import styled from 'styled-components';

const VideoContainer = styled.div`
    position: relative;
    width: 100vw;
    height: 96vh;
    overflow: hidden;
`;

const VideoIframe = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    transform: translate(-50%, -50%);
    iframe {
        width: 100vw;
        height: 56.25vw; /* 16:9 aspect ratio */
        min-height: 100vh;
        min-width: 177.78vh; /* 16:9 aspect ratio */
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        pointer-events: none; /* Disable user events */
    }
`;

const VideoOverlay = styled.div`
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.55);
`

const FullViewportVideo = ({ videoId }) => {
    const opts = {
        playerVars: {
            autoplay: 1,
            controls: 0,
            showinfo: 0,
            modestbranding: 1,
            loop: 1,
            playlist: videoId, // Ensure the video loops
            rel: 0,
            fs: 0,
            mute: 1, // Mute the video to ensure autoplay works
        },
    };

    return (
        <VideoContainer>
            <VideoIframe>
                <YouTube videoId={videoId} opts={opts} />
            </VideoIframe>
            <VideoOverlay />
        </VideoContainer>
    );
};

export default FullViewportVideo;
